import { useRouteLoaderData } from 'react-router-dom';
import { paths } from '@mosey/api-types';

type LocationSummary =
  paths['/api/legal_entity/locations/summary_v2']['get']['responses']['200']['content']['application/json'];

export const useLocationsSummary = () => {
  const summary = useRouteLoaderData('locations');

  if (!summary) {
    return {
      mail: {},
      question_tasks: {},
      requirement_tasks: {},
      wizards: {},
    } satisfies LocationSummary;
  }

  return summary as LocationSummary;
};
